import * as actionTypes from "../../actions/meta/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  meta: null,
  error: null,
  isCreated: false,
  isUpdated: false,
  loading: false,
};

export const metaStart = (state, action) => {
  return updateObject(state, {
    meta: null,
    error: null,
    isCreated: false,
    isUpdated: false,
  });
};
export const metaLoading = (state, action) => {
  return updateObject(state, {
    loading: true,
  });
};

export const metaFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

export const getMeta = (state, action) => {
  return updateObject(state, {
    meta: action.response,
    loading: false,
  });
};

export const createMeta = (state, action) => {
  return updateObject(state, {
    isCreated: true,
    loading: false,
  });
};

export const updateMeta = (state, action) => {
  return updateObject(state, {
    isUpdated: true,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.META_START:
      return metaStart(state, action);
    case actionTypes.META_LOADING:
      return metaLoading(state, action);
    case actionTypes.META_FAIL:
      return metaFail(state, action);
    case actionTypes.GET_META_SUCCESS:
      return getMeta(state, action);
    case actionTypes.CREATE_META_SUCCESS:
      return createMeta(state, action);
    case actionTypes.UPDATE_META_SUCCESS:
      return updateMeta(state, action);
    default:
      return state;
  }
};

export default reducer;
